import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service'; 
@Component({
  selector: 'app-scope-of-bba',
  templateUrl: './scope-of-bba.component.html',
  styleUrls: ['./scope-of-bba.component.scss']
})
export class ScopeOfBbaComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;
  ngOnInit(): void {
  }

}
